import { Injectable, inject } from '@angular/core';

import { InspectionCategoryDBService } from '../db/inspection-category-db-service';
import { Resolve } from '@angular/router';
import { InspectionElementDto } from '@core/api';

@Injectable()
export class InspectionCategoriesResolver implements Resolve<InspectionElementDto[]> {
  private inspectionCategoryDbService = inject(InspectionCategoryDBService);

  public resolve() {
    return this.inspectionCategoryDbService.getAllInspectionCategories();
  }
}
